import { PhoneNumber } from '@app/core/interfaces/c5/phone-number';
import { ScreenNumber } from '@app/core/interfaces/screen-number';

/**
 * Asserts the screening-number if it is a billable number.
 * Current assertion is based on `IN_OUT` screening-number direction and to be a network-provided number.
 */
export function isScreenNumberBillable(number: ScreenNumber): boolean {
  const isInOut = number.dir === 'IN_OUT';
  const isNetProvided = number.netNumber === true;

  return isInOut && isNetProvided;
}

/**
 * Asserts the phone-number  if it is a billable number.
 * Current assertion is based on `IN_OUT` or `IN` number direction, having `screenNumberId` field set,
 * and to be a network-provided number.
 */
export function isPhoneNumberBillable(number: PhoneNumber): boolean {
  const hasScreenNumberSet = number.screenNumId != undefined && number.screenNumId !== 0;
  const isInOut = number.dir === 'IN_OUT';
  const isIn = number.dir === 'IN';
  const hasValidDirection = isInOut || isIn;
  const isNetProvided = number.netNumber === true;
  const isVisible = number.hide === false;

  return hasScreenNumberSet && hasValidDirection && isNetProvided && isVisible;
}
